import React from 'react'

export function StyledCheck() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="104"
            fill="none"
            viewBox="0 0 104 104">
            <path fill="#E5E5E5" d="M0 0H104V104H0z"></path>
            <g>
                <path
                    fill="#15CF74"
                    fillOpacity="0.12"
                    d="M-5094-668c0-1.105.9-2 2-2H8564c1.1 0 2 .895 2 2v3441c0 1.1-.9 2-2 2H-5092c-1.1 0-2-.9-2-2V-668z"></path>
                <g clipPath="url(#clip0_1968_128497)">
                    <path
                        fill="#F5EBDC"
                        d="M0 0H414V1437H0z"
                        transform="translate(-155 -468)"></path>
                    <g>
                        <rect
                            width="366"
                            height="398"
                            x="-131"
                            y="-36"
                            fill="#FAF3E8"
                            rx="12"></rect>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <path
                                            fill="#198337"
                                            d="M61.224 74.318c-2.454 3.9-4.482 5.824-7.696 5.824-3.64 0-6.375-2.049-8.83-5.949C38.564 64.49 34.185 60.237 28.497 51.2c-7.696-12.272 8.122-20.228 14.258-8.632 3.234 6.136 4.711 8.382 8.06 13.51 1.227 1.892 3.432 2.1 4.66.208 3.348-5.128 17.554-36.286 20.789-42.422 6.136-11.596 22.87-3.245 15.173 9.017-5.688 9.037-24.086 41.714-30.222 51.417l.01.021z"></path>
                                        <path
                                            fill="#502314"
                                            d="M90.312 43.795c-.51-2.08-1.518-4.285-2.641-6.396-2.112 3.837-4.39 8.06-6.656 12.251C75.118 60.54 69.034 71.792 65.82 76.867c-2.402 3.827-5.761 7.737-12.448 7.737-6.688 0-10.047-3.91-12.439-7.727-3.016-4.773-5.647-8.247-8.185-11.617-2.516-3.338-5.127-6.79-8.028-11.398-2.985-4.753-3.35-9.922-.988-14.175 2.277-4.129 6.864-6.791 11.679-6.791s9.287 2.724 11.793 7.477c2.496 4.743 3.931 7.104 6.043 10.39 2.828-5.387 7.925-16.13 11.845-24.398 1.3-2.756 2.528-5.336 3.62-7.613-.479-.25-.947-.51-1.436-.75-3.879-1.798-8.486-2.297-12.636-2.755-4.18-.479-7.852-.291-12.032.447-4.212.8-8.487 3.182-12.054 5.315-3.609 2.131-6.864 4.773-9.6 7.956-2.766 3.171-4.523 7.113-6.167 10.868-1.59 3.754-3.588 7.612-4.066 11.866-.405 4.233.364 8.403 1.175 12.49.53 2.6 1.331 5.138 2.371 7.592 2.434 5.71 6.553 10.494 11.212 14.612 2.787 2.465 5.793 4.763 9.245 6.323 3.87 1.758 7.852 2.476 12.002 3.006 4.16.489 8.684.593 12.865-.24 4.617-.977 9.068-2.755 12.937-5.376 3.848-2.61 7.426-5.48 10.213-9.245 2.819-3.786 5.96-7.717 7.176-12.439 1.04-4.004 1.591-8.621 2.111-12.698.01-.083.01-.26 0-.52-.166-3.963-.81-7.561-1.716-11.399v-.01z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                <path
                    fill="#000"
                    fillOpacity="0.1"
                    d="M-5092-669H8564v-2H-5092v2zm13657 1v3441h2V-668h-2zm-1 3442H-5092v2H8564v-2zm-13657-1V-668h-2v3441h2zm1 1c-.55 0-1-.45-1-1h-2c0 1.66 1.34 3 3 3v-2zm13657-1c0 .55-.45 1-1 1v2c1.66 0 3-1.34 3-3h-2zm-1-3442c.55 0 1 .448 1 1h2c0-1.657-1.34-3-3-3v2zm-13656-2c-1.66 0-3 1.343-3 3h2c0-.552.45-1 1-1v-2z"></path>
            </g>
            <defs>
                <clipPath id="clip0_1968_128497">
                    <path
                        fill="#fff"
                        d="M0 0H414V1437H0z"
                        transform="translate(-155 -468)"></path>
                </clipPath>
            </defs>
        </svg>
    )
}
